import { useGetRagEarningsQuery } from '../../store/api/agentsApi'
import { Alert, StatCards } from '../../components/ui'
import { getErrorMessage } from '../../lib/apiClient'
import { AdminRefreshBtn } from './AdminRefreshBtn'
import s from '../../styles/pages/AdminPage.module.css'

const fmtRupees = (paise: number) => `₹${(paise / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
const fmtDate = (iso: string) => new Date(iso).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })

// ── Main tab ──────────────────────────────────────────────────────
export function AdminRagEarnings() {
  const { data, isFetching, error, refetch } = useGetRagEarningsQuery()

  const totals = data?.totals ?? { totalCollectedPaise: 0, earningsPaise: 0, gstPaise: 0, paymentCount: 0 }
  const rows = data?.byAgent ?? []

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.4rem' }}>
        <div style={{ fontWeight: 600, color: 'var(--text-primary)' }}>📚 RAG Payouts</div>
        <AdminRefreshBtn onClick={() => void refetch()} loading={isFetching} />
      </div>
      <p style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginBottom: '1rem' }}>
        Hosting subscriptions that creators pay to upload knowledge documents (PDF / Word) to their hosted agents.
        There is no revenue share here — this is 100% Ekkam's earnings. Earnings are shown excluding GST.
      </p>

      {error && <Alert variant="error" style={{ marginBottom: '1rem' }}>{getErrorMessage(error, 'Failed to load RAG payouts')}</Alert>}

      <StatCards
        style={{ marginBottom: '1.25rem' }}
        stats={[
          { icon: '🏦', label: 'Ekkam Earnings (all-time, ex-GST)', value: fmtRupees(totals.earningsPaise) },
          { icon: '💰', label: 'Total Collected (incl. GST)',       value: fmtRupees(totals.totalCollectedPaise) },
          { icon: '🧾', label: 'GST Collected',                     value: fmtRupees(totals.gstPaise) },
          { icon: '📄', label: 'Paid Subscriptions',                value: totals.paymentCount.toLocaleString('en-IN') },
        ]}
      />

      <div className={s.listCard} style={{ marginBottom: '1.5rem' }}>
        {isFetching && rows.length === 0 && <div className={s.listCardLoading}>Loading…</div>}
        {!isFetching && rows.length === 0 && <div className={s.listCardEmpty}>No RAG subscription payments yet.</div>}
        {rows.map((row, i) => (
          <div key={row.agentId} style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.65rem 1rem', borderBottom: i < rows.length - 1 ? '1px solid var(--border)' : 'none', flexWrap: 'wrap' }}>
            <div style={{ flex: '1 1 160px', minWidth: 0 }}>
              <div style={{ fontWeight: 600, fontSize: '0.85rem', color: 'var(--text-primary)' }}>{row.agentName}</div>
              <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>
                {row.developerName} · {row.planName} · {row.subscriptionStatus} · {row.paymentCount} payment{row.paymentCount === 1 ? '' : 's'} · last {fmtDate(row.lastPaidAt)}
              </div>
              <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>
                Collected {fmtRupees(row.totalCollectedPaise)} · GST {fmtRupees(row.gstPaise)}
              </div>
            </div>
            <div style={{ fontWeight: 700, fontSize: '0.9rem', flexShrink: 0, color: 'var(--success)' }}>
              {fmtRupees(row.earningsPaise)}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
